import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { TRACKING_CODE_PATTERN } from '../lib/apiClient';
import { UI_COPY, type SupportedLanguage } from '../i18n/uiCopy';

export function Home({ language, setLanguage }: { language: SupportedLanguage; setLanguage: (l: SupportedLanguage) => void }) {
  const copy = UI_COPY[language];
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [touched, setTouched] = useState(false);

  const normalized = code.trim().toUpperCase();
  const isValid = TRACKING_CODE_PATTERN.test(normalized);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setTouched(true);
    if (!isValid) return;
    navigate(`/track/${normalized}?lang=${language}`);
  }

  return (
    <div className="page">
      <TopBar copy={copy} language={language} onLanguageChange={setLanguage} />
      <main>
        <div className="card">
          <h1>{copy.homeHeading}</h1>
          <p className="subheading">{copy.homeSubheading}</p>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <label htmlFor="tracking-code">{copy.inputLabel}</label>
              <input
                id="tracking-code"
                type="text"
                value={code}
                placeholder={copy.inputPlaceholder}
                autoComplete="off"
                autoCapitalize="characters"
                onChange={(e) => setCode(e.target.value)}
                onBlur={() => setTouched(true)}
              />
            </div>
            {touched && !isValid && code.length > 0 && <div className="banner critical">{copy.invalidCodeError}</div>}
            <button className="primary" type="submit" disabled={code.length > 0 && !isValid}>
              {copy.trackButton}
            </button>
          </form>
        </div>
      </main>
      <footer>{copy.footerNote}</footer>
    </div>
  );
}
